import { render } from "./DataTablesMenu.vue?vue&type=template&id=21536ffb"
const script = {}

import "./DataTablesMenu.vue?vue&type=style&index=0&id=21536ffb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__